module.exports = __webpack_public_path__ + "media/images/or_icon_green-dbf7036016f912c57d68917c332d6fd1.png";